import { calculateColeParameters } from "./calculateColeParameters";

export default impedanceVector => calculateColeParameters(impedanceVector);
